// src/components/kanban/UserMultiSelect.tsx
/**
 * MultiSelect per la scelta di più utenti (assegnatari task Kanban), con avatar colore
 * nell'opzione. I valori sono id numerici; Mantine MultiSelect lavora internamente con
 * stringhe, quindi la conversione avviene ai bordi del componente.
 */
import { Avatar, Group, MultiSelect, Text } from '@mantine/core';
import { useSimpleUsers } from '../../hooks/use-users';

interface UserMultiSelectProps {
  value: number[];
  onChange: (ids: number[]) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

export default function UserMultiSelect({
  value,
  onChange,
  label,
  placeholder = 'Seleziona persone…',
  disabled,
}: UserMultiSelectProps) {
  const { data: users = [], isLoading } = useSimpleUsers();

  const data = users.map((u) => ({ value: String(u.id), label: u.fullName }));
  const usersById = new Map(users.map((u) => [String(u.id), u]));

  return (
    <MultiSelect
      label={label}
      placeholder={isLoading ? 'Caricamento…' : placeholder}
      data={data}
      value={value.map(String)}
      onChange={(vals) => onChange(vals.map(Number))}
      searchable
      clearable
      disabled={disabled || isLoading}
      nothingFoundMessage="Nessuna persona trovata"
      renderOption={({ option }) => {
        const user = usersById.get(option.value);
        return (
          <Group gap="xs" wrap="nowrap">
            <Avatar
              size={22}
              radius="xl"
              color={user?.colorTag ? undefined : 'blue'}
              style={user?.colorTag ? { backgroundColor: user.colorTag, color: '#fff' } : undefined}
            >
              {initials(option.label)}
            </Avatar>
            <Text size="sm">{option.label}</Text>
          </Group>
        );
      }}
    />
  );
}

function initials(fullName: string): string {
  return fullName
    .split(' ')
    .filter(Boolean)
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
